export default __webpack_public_path__ + "static/media/Mask-group.d496b331.svg";